import $$ from 'cmn-utils';

//查询终端分组数量
export async function initHomePage(payload) {
	return $$.post('/home/initHomePage', payload);
}

//用户设置
export async function updatePassword(payload) {
	return $$.post('/user/updatePassword', payload);
}

//修改冒泡提示和Logo
export async function updateTipStatusAndLogo(payload) {
	return $$.post('/user/updateTipStatusAndLogo', payload);
}

//状态提醒设置
export async function updateUserRemindStatus(payload) {
	return $$.post('/user/updateUserRemindStatus', payload);
}

//根据id查询用户
export async function qryUserById(payload) {
	return $$.post('/user/qryUserById', payload);
}

//查询终端异常
export async function qryMessagesOfClient(payload) {
	return $$.post('/message/qryMessagesOfClient', payload);
}

//日程审核消息
export async function qryMessagesOfSchedule(payload) {
	return $$.post('/message/qryMessagesOfSchedule', payload);
}

//互动日程
export async function qryMessagesOfTouSchedule(payload) {
	return $$.post('/message/qryMessagesOfTouSchedule', payload);
}

//批量置为已读
export async function batchUpdateClientMessages(payload) {
	return $$.post('/message/batchUpdateClientMessages', payload);
}

//全部置为已读
export async function clearClientMessages(payload) {
	return $$.post('/message/clearClientMessages', payload);
}

//查询消息总数
export async function qryTotalMessageCount() {
	return $$.post('/message/qryTotalMessageCount');
}

//查询终端近一周流量使用情况
export async function qryClientFluxStatisticsData(payload) {
	return $$.post('/client/qryClientFluxStatisticsData', payload);
}

//根据省份查询终端数量
export async function qryClientCountByProvince(payload) {
	return $$.post('/client/qryClientCountByProvince', payload);
}

//根据地区查询终端数量
export async function qryClientQuantityByArea(payload) {
	return $$.post('/client/qryClientQuantityByArea', payload);
}

//查询终端数量Top10
export async function qryUserClientCountTop10(payload) {
	return $$.post('/user/qryUserClientCountTop10', payload);
}




// WEBPACK FOOTER //
// ./src/routes/HomePage/service/index.js